import React from 'react';

const RightBar = () => {
    return (
        <div className='app__rightbar'>
           <a href="mailto:juuso.rutanen@gmail.com" className="app__rightbar-email" aria-label="Send email to Juuso Rutanen">juuso.rutanen@gmail.com</a>
            <span className='app__vertical-line-right'></span>
        </div>
    )
}

export default RightBar;